import "./TrainingApplicationSupport.module.css";
import Header from "@/reusable_sections/Header";
import TrainingSupport from "./sections/TrainingSupport";
import Modalities from "./sections/Modalities";
import Support from "./sections/Support";
import Footer from "@/reusable_sections/Footer";
export default function TrainingApplicationSupportPage() {
  return <div>
      <Header />
      <TrainingSupport />
      <Modalities />
      <Support />
      <Footer />
    </div>;
}